import React, { useEffect, useState, useContext } from 'react';
// import { language } from 'config';
import PaypalIcon from '../assets/payment-icons/paypal-logo.png';
//import StripeIcon from '../assets/payment-icons/stripe-logo.png';
import {
    Button, Modal, Box,
    Typography
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FirebaseContext } from 'common';
import Paypal from "../payment/paypal";
import Stripe from "../payment/stripe";
import AlertDialog from '../components/AlertDialog';

const providers = [
    {
        name: 'Paypal',
        icon: PaypalIcon,
        
    },
    // { 
    //     name: 'Stripe',
    //     icon:StripeIcon
    // }
]

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 30,
};

// const stylepay = {
//  height: 300,
// };

export default function SelectGatewayPage({ paymentData }) {
    const { api } = useContext(FirebaseContext);
    const {
        updateWalletBalance,
        addBooking,
        addSubscription,
        fetchUser
    } = api;
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const settings = useSelector(state => state.settingsdata.settings);
    const payData = {
        amount: paymentData.amount,
        // currency: settings?.code || "EUR" || "USD",
        currency: "EUR",
    }
    const onSuccess = (data) => {
        if (paymentData.paymentType === 'subscription' && paymentData?.data?.planId) {
            addSubscription(auth?.info?.uid || paymentData?.data?.uid, paymentData?.data?.planId).then((res) => {
                if (res && res.success) {
                    handleClose()
                    if (paymentData?.data?.goToLogin) {
                        paymentData?.data?.goToLogin.push('/login');
                    } else {
                        dispatch(fetchUser())
                    }
                } else if (res && res.error) {
                    setCommonAlert({ open: true, msg: res.error })
                }
            }).catch((err) => {
                setOpen(false)
                setSelectedProvider('')
                setCommonAlert({ open: true, msg: JSON.stringify(err) })
            })
        } 
        else if (paymentData.paymentType === 'walletBalance' && auth?.info) {
            let walletBalance = parseFloat(auth?.info?.profile?.walletBalance) + parseFloat(payData.amount);
            let tDate = new Date();
            let time = tDate.getTime(); 
            let details = {
                type: 'Credit',
                amount: parseFloat(payData.amount),
                date: tDate.toString(),
                txRef: time.toString(),
                gateway: selectedProvider,
                transaction_id: data.id
            }
            dispatch(updateWalletBalance(walletBalance, details));
            handleClose();
        }
        else if (paymentData.paymentType === 'booking' && auth?.info) {
            let curBooking = { ...paymentData.data };
            dispatch(addBooking(curBooking));
        }
    } 
    const onCancel = () => {
        handleClose()
        if (paymentData?.data?.goToLogin) {
            paymentData?.data?.goToLogin.push('/login');
        } 
    }
    
    // modal logic
    const [open, setOpen] = useState(false);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
    const [selectedProvider, setSelectedProvider] = useState('');
    const handleClose = () => {
        setOpen(false)
        setSelectedProvider('')
    };
    const handleAlertClose = () => {
        setCommonAlert({ open: false, msg: "" })
    };
    useEffect(() => {
        if(paymentData.paymentType)
             setOpen(true);
    }, [paymentData])

    const selectProvider = (provider) => {
        setSelectedProvider(provider)
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    {selectedProvider === 'Paypal' && <Paypal payData={payData} onSuccess={onSuccess} onCancel={onCancel} />}
                    {selectedProvider === 'Stripe' && <Stripe payData={payData} onSuccess={onSuccess} onCancel={onCancel} />}
                    {!selectedProvider&&<>
                    <Typography align="center">
                      Πιστωτικη-χρεωστικη καρτα και Paypal
                    </Typography>
                        {providers.map(provider => {
                        return (
                            <Button variant="text" key={provider.name} onClick={() => selectProvider(provider.name)}>
                                <img src={provider.icon} width="130px" height="120px"/>
                            </Button>
                        )
                        })}
                    </>}
                    <Box sx={{ display: 'flex', justifyContent:'space-evenly'}}>
                        {selectedProvider && <Button variant="outlined" onClick={() => setSelectedProvider('')}>
                            Πiσω
                        </Button>}
                        <Button variant="contained" onClick={() => handleClose()}>
                            Aκυρο
                        </Button>
                    </Box>
             </Box>
            </Modal>
            <AlertDialog open={commonAlert.open} onClose={handleAlertClose}>{commonAlert.msg}</AlertDialog>
        </div>
    )
}
